document.addEventListener('DOMContentLoaded', () => {
  const opener = document.querySelector('.compare_sizes__drawer_opener');
  const drawer = document.querySelector('.drawer--compare_sizes');
  const overlay = drawer?.querySelector('.drawer__overlay');
  const closeBtn = drawer?.querySelector('.drawer__close');
  const productInfo = document.querySelector('.product__info');

  if (!opener || !drawer) return;

  const openDrawer = () => {
    drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
    productInfo?.classList.add('drawer-opened');
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    productInfo?.classList.remove('drawer-opened');
  };

  opener.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  });

  overlay?.addEventListener('click', closeDrawer);
  closeBtn?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer();
    }
  });
});